<template>
    <div>
        <v-menu
            v-model="modal"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    :value="formattedDate"
                    :label="label"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :color="inputColor"
                    outlined
                    :background-color="inputBackgroundColor"
                    clearable
                    @click:clear="clear"
                    dense
                    hide-details="auto"
                    :rules="rules"
                ></v-text-field>
            </template>
            <v-date-picker
                v-model="date"
                :readonly="readonly"
                :disabled="readonly"
                locale="fr-fr"
                color="teal"
                @input="save"
                type="month"
            ></v-date-picker>
        </v-menu>
        <input type="hidden"/>
    </div>
</template>

<script>
import {computed, ref, watch} from "vue";
import useTools from "@/use/Tools";
import useSharedData from "@/use/SharedData";

export default {
    props: {
        value: String,
        label: String,
        min: String,
        rules: Array,
        readonly: Boolean,
    },
    setup(props, {emit}) {
        const {$moment} = useTools();
        const {inputColor, inputBackgroundColor} = useSharedData();
        const modal = ref(false);
        const date = ref(null);

        const formattedDate = computed(() => date.value ? $moment(date.value).format("MM-YYYY") : null)

        function save() {
            modal.value = false;
            emit("input", date.value);
        }

        function clear() {
            date.value = null;
            emit("input", null);
        }

        watch(() => props.value, () => {
            if (props.value)
                date.value = props.value;
        }, {immediate: true});

        return {
            inputColor,
            inputBackgroundColor,
            modal,
            date,
            formattedDate,
            save,
            clear
        }
    }
};
</script>